<div *routerOuter class="row">
  <div class="col col-120 col-lg-100 col-xl-80" *ngIf="item">

    <form-group-context label="ID">
      <span>{{ item.id }}</span>
    </form-group-context>

    <form-group-context label="Created At">
      <span>{{ item.createdAt | moment }}</span>
    </form-group-context>

    <form-group-context label="Updated At">
      <span>{{ item.updatedAt | moment }}</span>
    </form-group-context>

    <form-group-context label="Name">
      <span>{{ item.name }}</span>
    </form-group-context>

    <form-group-context label="Description">
      <span>{{ item.description }}</span>
    </form-group-context>

    <form-group-context label="Key">
      <span>{{ item.key }}</span>
    </form-group-context>

    <form-group-context label="Google product ID">
      <span>{{ item.googlePackageName }}</span>
    </form-group-context>

    <form-group-context label="Apple product ID">
      <span>{{ item.applePackageName }}</span>
    </form-group-context>

    <form-group-context label="Duplicate store">
      <button class="btn btn-icon btn-warning"
              [hidden]="!item"
              (click)="duplicate()">
        <span>Duplicate</span>
      </button>
    </form-group-context>
  </div>
</div>
